import React, { useEffect, useState, useContext } from 'react';
import './OverallShares.css';
import axios from 'axios';
import { FilterContext } from './FilterContext';
import Filters from './Filters';
import config from '../../config';
import { useNavigate } from 'react-router-dom';
import './PaymentMethodViews.css';

const DigitalNonDigital = () => {
  const { selectedFilters, DisplayFiltersName } = useContext(FilterContext);
  const [brands, setBrands] = useState([]);
  const [data, setData] = useState([]);
  const [waves, setWaves] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [baseValue, setBaseValue] = useState(null);
  const [apiCalled, setApiCalled] = useState(false);
  const navigate = useNavigate();
  const [isDownloading, setIsDownloading] = useState(false);


  useEffect(() => {
    if (selectedFilters && Object.keys(selectedFilters).length > 0) {
      const filteredFilters = Object.fromEntries(
        Object.entries(selectedFilters).filter(([key, value]) => Array.isArray(value) && value.length > 0)
      );

      if (Object.keys(filteredFilters).length > 0) {
        setLoading(true);
        setApiCalled(false);

        axios
          .post(`${config.API_BASE_URL}/api/Overallshares`, {
            selectedFilters,
            groupId: 10, // Adjust groupId as per BrandShare logic
          })
          .then((response) => {
            const { Brands, Data, Waves } = response.data;
            setBrands(Brands || []);
            setData(Data || []);
            setWaves(Waves || []);
            if (response.data.Data?.length > 0) {
              const seenWindex = new Set();
              let totalBase = 0;

              for (let i = 0; i < response.data.Data.length; i++) {
                const item = response.data.Data[i];
                if (!seenWindex.has(item.windex)) {
                  totalBase += item.Base || 0;
                  seenWindex.add(item.windex);
                }
              }
              const roundedBase = Math.round(totalBase);
              setBaseValue(roundedBase.toLocaleString());
            }
            setApiCalled(true);
            setLoading(false);
          })
          .catch((err) => {
            console.error('Error fetching data:', err);
            setError('Failed to load data.');
            setApiCalled(true);
            setLoading(false);
          });
      }
    } else {
      setLoading(false);
      setData([]);
      setApiCalled(false);
    }
  }, [selectedFilters]);

  const goBack = () => navigate('/dashboards');

  const renderSelectedFilters = () => {
    let renderedTransYear = false; // Flag to track if 'trans_year' has been rendered
    const subCategoryValues = []; // To accumulate sub-category values
    const renderContent = [];
    const brandValues = [];

    // Loop through the filter names and render them
    Object.keys(DisplayFiltersName).map((displayName) => {
      const filterKey = DisplayFiltersName[displayName]; // Get the object for the current display name

      // If the filterKey is an array (like 'trans_year' or any other arrays), handle them
      if (Array.isArray(filterKey)) {
        // If it's 'trans_year' and has not been rendered, render it
        if (displayName === "trans_year" && !renderedTransYear) {
          renderedTransYear = true;
          renderContent.push(
            <span key={displayName} className="selected-filter">
              <strong>Year: </strong>{filterKey.join(", ")}
            </span>
          );
        }
        return; // Skip further handling for arrays (no need to process this again)
      }

      // Get the keys from the filterKey object (like user_age, user_gender)
      const filterKeys = Object.keys(filterKey);

      // Loop through each filter key (like user_age, user_gender)
      filterKeys.map((key) => {
        const filterValues = selectedFilters[key];

        // Skip rendering if filterValues is empty or undefined
        if (!filterValues || (Array.isArray(filterValues) && filterValues.length === 0)) {
          return null;
        }

        // Skip rendering 'trans_year' if it's already been rendered
        if (key === "trans_year" && renderedTransYear) {
          return; // Skip if 'trans_year' has already been rendered
        }

        // ✅ Handle Sub-Categories
        if (displayName === "Sub-Categories" || key.startsWith("SubCat_")) {
          if (Array.isArray(filterValues)) {
            subCategoryValues.push(...filterValues);
          } else {
            subCategoryValues.push(filterValues);
          }
          return null;
        }

        // ✅ Handle Brand
        if (displayName === "Brand" || key.startsWith("Brand_")) {
          if (Array.isArray(filterValues)) {
            brandValues.push(...filterValues);
          } else {
            brandValues.push(filterValues);
          }
          return null;
        }

        // For other filters, display the regular displayName
        const displayKey = key === "trans_year" ? "Year" : displayName;
        const displayValues = Array.isArray(filterValues) ? filterValues.join(", ") : filterValues;

        renderContent.push(
          <span key={key} className="selected-filter">
            <strong>{displayKey}: </strong>{displayValues}
          </span>
        );
      });
    });

    // ✅ Render Sub-Categories
    if (subCategoryValues.length > 0) {
      renderContent.push(
        <span key="sub-categories" className="selected-filter">
          <strong>Sub-Categories: </strong>{subCategoryValues.join(", ")}
        </span>
      );
    }

    // ✅ Render Brand
    if (brandValues.length > 0) {
      renderContent.push(
        <span key="brand" className="selected-filter">
          <strong>Brand: </strong>{brandValues.join(", ")}
        </span>
      );
    }

    return renderContent;
  };

  const getValue = (brandId, waveId) => {
    const entry = data.find(d => d.BrandId === brandId && d.WaveId === waveId);
    return entry ? `${entry.Share}%` : '-';
  };

  const downloadTableData = async (selectedFilters) => {
    if (!data || !data.length) {
      alert("No data available to download.");
      return;
    }
    setIsDownloading(true); // show popup

    try {
      const kpi = "Digital vs. Non-Digital"
      const response = await axios.post(
        `${config.API_BASE_URL}/download-data`,  // Replace with your actual API endpoint
        {
          selectedFilters: selectedFilters,
          Kpi: kpi,
          groupId: 10
        },
        { responseType: 'blob' } // Ensures file download
      );

      // Create a download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', kpi + '.xlsx'); // Change file name/format if needed
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Error downloading data:", error);
      alert("Failed to download data. Please try again.");
    } finally {
      setIsDownloading(false); // hide popup
    }
  };

  useEffect(() => {
    if (isDownloading) {
      document.body.classList.add('download-active');
    } else {
      document.body.classList.remove('download-active');
    }
  }, [isDownloading]);


  return (
    <div className="container">
      <Filters pageSpecificFilters="brand" />
      <div className="table-section">
        <div style={{ justifyContent: 'space-between', display: 'flex' }}>
          <button onClick={goBack} className="back-button">← Back</button>
          <button
            onClick={() => downloadTableData(selectedFilters)}
            className={`download-button ${!data?.length ? 'disabled' : ''}`}
            disabled={!data?.length}
          >
            <i className="fa fa-download"></i>&nbsp;
            <span className="download-text">Download Data</span>
          </button>
        </div>

        <div className="selected-filters-display">
          {renderSelectedFilters()}
        </div>


        {loading && (
          <div className="loader-container">
            <div className="loader"></div>
          </div>
        )}

        {error && <div className="error">{error}</div>}

        {!loading && apiCalled && (
          <div>
            {data.length === 0 ? (
              <div className="no-data-message">
                No data to display for selected filter.
              </div>
            ) : (
              <div className="scrollable-table">
                <table>
                  <thead>
                    <tr>
                      <th className="total-transac">
                        <u>Total Transactions</u>
                        <br />
                        <label className="label">
                          <i><strong>Base:</strong> {baseValue}</i>
                        </label>
                      </th>
                      <th className="share-column" colSpan={waves.length}>Share of Transactions</th>
                    </tr>
                    <tr>
                      <th>Payment Methods</th>
                      {waves.map((wave) => (
                        <th key={wave.Id}>{wave.Name}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="base-row">
                      <td><strong><i>Base: Weighed number of transactions</i></strong></td>
                      {waves.map((wave) => {
                        const value = data.find(d => d.windex === wave.Index);
                        return (
                          <td key={`base-${wave.Id}`}>
                            {value && value.Base !== undefined ? Math.round(value.Base).toLocaleString() : '-'}
                          </td>
                        );
                      })}
                    </tr>
                    {brands.map((brand) => (
                      <tr key={brand.Id} style={{ backgroundColor: `${brand.Color}`, textIndent: `${brand.Operator}` }}>
                        <td>{brand.Name}</td>
                        {waves.map((wave) => {
                          const value = data.find(d => d.bindex === brand.Index && d.windex === wave.Index);
                          return (
                            <td key={`${brand.Id}-${wave.Id}`}>
                              {value && value.Perc !== undefined && parseFloat(value.Perc) > 0
                                ? `${(Math.round(parseFloat(value.Perc) * 10) / 10).toFixed(1)}%`
                                : '-'}
                            </td>
                          );
                        })}
                      </tr>
                    ))}
                  </tbody>
                  {/* <tfoot>
                    <tr>
                      <td colSpan={waves.length + 1} className="table-note-footer">
                        <big><b>Note: Share is calculated on total transactions.</b></big>
                      </td>
                    </tr>
                  </tfoot> */}
                </table>
              </div>
            )}
          </div>
        )}

      </div>
      {isDownloading && (
        <div className="download-popup">
          <div className="popup-content">
            <div className="spinner"></div>
            <p>Preparing your download...</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default DigitalNonDigital;
